import React, { useEffect, useState } from 'react';

interface NamePromptModalProps {
  open: boolean;
  title: string;
  confirmLabel?: string;
  initialValue?: string;
  /** Optional helper text below the title */
  hint?: string;
  onConfirm: (name: string) => void;
  onCancel: () => void;
}

const NamePromptModal: React.FC<NamePromptModalProps> = ({
  open,
  title,
  confirmLabel = 'Save',
  initialValue = '',
  hint,
  onConfirm,
  onCancel,
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (open) setValue(initialValue);
  }, [open, initialValue]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40" role="dialog" aria-modal="true">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-5 border border-neutral-200">
        <h3 className="text-lg font-semibold text-neutral-900 mb-2">{title}</h3>
        {hint ? <p className="text-sm text-neutral-600 mb-3">{hint}</p> : null}
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              const t = value.trim();
              if (t) onConfirm(t);
            }
          }}
          className="w-full px-3 py-2 text-sm border border-neutral-300 rounded-md mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Enter a name…"
          autoFocus
        />
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm border border-neutral-300 rounded-md hover:bg-neutral-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => {
              const t = value.trim();
              if (!t) return;
              onConfirm(t);
            }}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NamePromptModal;
